export default __webpack_public_path__ + "static/featureCards_onBrand-c5f7054e4cbaf2f5cd6473c696d74912.mp4";